import React from 'react';
import { Accordion } from 'react-bootstrap';
import styled from 'styled-components';

import {
  headersLogs,
  valoresExibidosLogs,
  fieldObjectLogs,
} from './auxiliarLog';
import { getUser } from '../../modules/contexts/Auth/RequireAuth';
import { ExportToExcel } from '../../utils/functions';
import BarraInferiorBotoes from '../BarraInferiorBotoes';
import BoxConteudo from '../BoxConteudo';
import Tabela from '../Tabela';
import WorkspaceBotoes from '../WorkspaceBotoes';
import LogRegistro from './LogRegistro';
import { useLogData } from './useLogData';

const LogContainer = styled(Accordion)`
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;

  .accordion-button {
    color: 'black';
  }
  .accordion-item {
    border-radius: 20px;
    color: 'black';
  }
  .accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
  }
  .accordion-item:first-of-type > .accordion-header .accordion-button {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  .accordion-button:not(.collapsed) {
    background-color: white;
    box-shadow: none;
  }

  .accordion-button:focus {
    box-shadow: none;
  }
`;

interface LogProps {
  id?: number | undefined;
  dataRegistro?: string;
  usuarioRegistro?: string;
  dataAtualizacao?: string;
  usuarioAtualizacao?: string;
  nEdicoes?: number;
  entity?: string;
  refreshTriggerLog?: number;
}

const Log: React.FC<LogProps> = ({
  id = 0,
  dataRegistro,
  usuarioRegistro,
  dataAtualizacao,
  usuarioAtualizacao,
  nEdicoes,
  entity = '',
  refreshTriggerLog = 0,
}) => {
  const user = getUser();
  const userID = user.sub;

  const { logEntries, tableData } = useLogData(entity, id, refreshTriggerLog);

  const offcanvasData = tableData.map((entry) => {
    return {
      ...entry,
      Alterações: (
        <pre
          style={{
            whiteSpace: 'pre-wrap',
            margin: 0,
            fontSize: '0.85rem',
            fontFamily: 'monospace',
          }}
        >
          {entry.Alterações?.replace(/,/g, ',\n').replace(/},/g, '},\n\n')}
        </pre>
      ),
    };
  });

  return (
    <LogContainer>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Logs</Accordion.Header>
        <Accordion.Body>
          <LogRegistro
            {...{
              id,
              dataRegistro,
              usuarioRegistro,
              dataAtualizacao,
              usuarioAtualizacao,
              nEdicoes,
            }}
          />

          {entity && (
            <BoxConteudo boxTitulo="Histórico" fechado>
              <Tabela
                headers={headersLogs}
                dataTable={tableData ?? []}
                dataOffCanvas={offcanvasData}
                rowClickable={false}
                tituloCanvas="Log"
                showPagination={false}
                botaoAbrirOffCanvas={false}
              />
            </BoxConteudo>
          )}

          {entity && (
            <BarraInferiorBotoes>
              <WorkspaceBotoes
                download
                onClickDownload={() =>
                  ExportToExcel(
                    logEntries,
                    valoresExibidosLogs,
                    fieldObjectLogs,
                    `sisaf_logs_${entity}.xlsx`,
                    userID,
                    'DAF',
                    entity,
                  )
                }
              />
            </BarraInferiorBotoes>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </LogContainer>
  );
};

export default Log;
